import { EventInterface } from '@splidejs/splide';

export default function SplideNacFade( Splide, Components ) {
  const { bind } = EventInterface( Splide );
  const { Move } = Components;
  const { list } = Components.Elements;

  let endCallback;

  function mount() {
    // sometimes on "mount" it trigger also "resize" event, sometimes dont, so we have to do apply translate3d twice
	Splide.on('resize', function() {
		Array.prototype.forEach.call( Components.Elements.slides, function(slide, i) {
			slide.style.transform = `translate3d(-`+ Components.Elements.list.clientWidth * i +`px, 0px, 0px)`;
		});
	});

	Array.prototype.forEach.call( Components.Elements.slides, function(slide, i) {
		slide.style.opacity = ( Splide.index >= i ) ? 1 : 0;
		slide.style.transform = `translate3d(-`+ Components.Elements.list.clientWidth * i +`px, 0px, 0px)`; 
	if( Splide.index === i )
		slide.style.zIndex = 2;
	});
  }

  function start( index, done ) {

    setTimeout(function() {
      done();
    })

    Array.prototype.forEach.call( Components.Elements.slides, function(slide, i) {
      slide.style.transition = `opacity ${ Splide.options.speed }ms ease 0s`;
      slide.style.opacity = ( index >= i ) ? 1 : 0;
      slide.style.zIndex = 'inherit';
    });
  }

  function cancel() {
    list.style.transition = '';
  }

  return {
    mount,
    start,
    cancel,
  };
}